import { ApolloLink } from "@apollo/client";
import { addUserToRollbar } from "@/shared/utils/configs/confRollbar";

export default new ApolloLink((operation, forward) =>
  forward(operation).map((res) => {
    const response = res.data[Object.keys(res.data)[0]];
    const responseType =
      response && res.data[Object.keys(res.data)[0]].__typename;

    if (responseType === "Viewer") {
      addUserToRollbar({
        id: response.id,
        email: response.email,
        username: response.name,
      });
    }

    if (responseType === "AuthSucess") {
      addUserToRollbar({
        id: response.id,
        email: response.email,
      });
    }
    return res;
  })
);
